let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("hBbNs")), load("gHNgE")]).then(() => parcelRequire('2F6ud'));